import _d from '@repperjs/debug';
import { OpenPanel } from '@openpanel/web';
import { canSendToOpenPanel } from './canSendToOpenPanel.ts';
import { OPENPANEL_API_PATH } from './constants.ts';

const warn = _d('repper:warning');

/**
 * The OpenPanel browser SDK, or `undefined` while nothing may be sent (`canSendToOpenPanel`). The instance is created
 * on the first call that passes the gate and kept on `window.openpanel`, so in Germany and France the SDK is not even
 * constructed before consent (construction sends the first page view). Its `filter` re-checks the gate on every
 * event, so a later withdrawal of consent stops sending at once. The SDK writes no cookie or storage for us: its
 * constructor only reads `sessionStorage` (`openpanel-pending-revenues`), and it writes there only through
 * `pendingRevenue()`, which we never call. A throwing constructor is caught and yields `undefined`, so tracking can
 * never break the caller.
 */
export const getOpenPanel = () => {
    const clientId = process.env.PUBLIC_OPENPANEL_CLIENT_ID;
    if (typeof window === 'undefined' || !clientId || !canSendToOpenPanel()) {
        return undefined;
    }
    try {
        window.openpanel ??= new OpenPanel({
            clientId,
            apiUrl: OPENPANEL_API_PATH,
            trackScreenViews: true,
            trackOutgoingLinks: false,
            trackAttributes: false,
            trackHashChanges: false,
            filter: () => canSendToOpenPanel(),
        });
    } catch (e) {
        warn('OpenPanel could not start', e);
        return undefined;
    }
    return window.openpanel;
};
